import React from 'react';
import BaseMessageModal, { ModalMode, EntityType } from './BaseMessageModal';

const CreateMessageModal = ({ 
  entityType = EntityType.DOCUMENT,
  documentId, 
  consultationId,
  patientData, 
  doc, 
  consultation,
  onClose, 
  onMessageSent, 
  templateRefreshTrigger = 0,
  autoOpenGenerateConfirmation = false,
}) => {
  return (
    <BaseMessageModal
      mode={ModalMode.PATIENT_MESSAGE}
      entityType={entityType}
      documentId={documentId}
      consultationId={consultationId}
      patientData={patientData}
      doc={doc}
      consultation={consultation}
      onClose={onClose}
      onMessageSent={onMessageSent}
      templateRefreshTrigger={templateRefreshTrigger}
      autoOpenGenerateConfirmation={autoOpenGenerateConfirmation}
    />
  );
};

export default CreateMessageModal;
